// src/Pages/Blog/blogData.js

import socialMediaCosts2024 from './posts/social-media-costs-2024';
import postingFrequency2025 from './posts/posting-frequency-2025';
import startingFromZero2024 from './posts/starting-from-zero-2024';
import contentCreationMatrix2024 from './posts/content-creation-matrix-2024';
import afterHoursCustomerService2024 from './posts/after-hours-customer-service-2024';
import wave3AiAdoption2025 from './posts/wave3-ai-adoption-small-business-2025';
import trainAiOnYourBusiness from './posts/train-ai-on-your-business';
import respondToNegativeGoogleReviews from './posts/respond-to-negative-google-reviews';
import aiGoogleReviewRepliesStudy from './posts/ai-google-review-replies-study';



export const BLOG_POSTS = [
  wave3AiAdoption2025,          // Featured — most current, matches homepage narrative
  respondToNegativeGoogleReviews,
  trainAiOnYourBusiness,
  socialMediaCosts2024,
  postingFrequency2025,
  startingFromZero2024,
  contentCreationMatrix2024,
  afterHoursCustomerService2024,
  aiGoogleReviewRepliesStudy,
];

export default BLOG_POSTS;